<template>
  <LvContentTabBar001
    height
    :selected-tab-id="state"
    :content-tabs="tabs"
    @click="$_onClick($event)"
  />
</template>

<script>
export default {
  data() {
    return {
      state: "question-list",
      tabs: [
        {
          id: "question-list",
          textLabel: "題目",
        },
        {
          id: "remark-list",
          textLabel: "記錄列表",
        },
      ],
    }
  },
  methods: {
    $_onClick($event) {
      this.state = $event.id
    }
  }
}
</script>